class BeautyMediaZoom extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.track.element,
      'mousemove',
      this.onMove.bind(this),
    )
    this.listeners.add(
      this.els.track.element,
      'mousedown',
      this.onStart.bind(this),
    )
    this.listeners.add(
      this.els.track.element,
      'mouseup',
      this.onStop.bind(this),
    )
    this.listeners.add(
      this.els.track.element,
      'mouseleave',
      this.onStop.bind(this),
    )

    this.externalEls.trigger.elements.forEach((trigger) => {
      this.listeners.add(trigger, 'click', this.onOpen.bind(this))
    })

    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.onClose.bind(this))
    })
  }

  onStart (e) {
    this.scrolling = true
    this.startX = e.pageX - this.els.track.element.offsetLeft
    this.scrollLeft = this.els.track.element.scrollLeft
  }

  onMove (e) {
    e.preventDefault()

    if (!this.scrolling) return

    const x = e.pageX - this.els.track.element.offsetLeft
    const scroll = x - this.startX

    this.els.track.element.scrollLeft = this.scrollLeft - scroll
  }

  onStop () {
    this.scrolling = false
  }

  onOpen (e) {
    this.ariaHidden = false

    const index = parseInt(
      e.target.closest('[data-beauty-media-zoom-external-el="trigger"]').dataset
        .index,
    )
    const left = this.els.track.element.clientWidth * index
    this.els.track.element.scrollLeft = left
  }

  onClose () {
    this.ariaHidden = true
  }

  get scrolling () {
    return this._scrolling
  }

  set scrolling (scrolling) {
    this._scrolling = scrolling

    this.els.track.element.classList.toggle(
      'prd-BeautyMediaZoom_Inner-scrolling',
      scrolling,
    )
  }
}

if (!customElements.get('beauty-media-zoom')) {
  customElements.define('beauty-media-zoom', BeautyMediaZoom)
}
